var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9856 30H5.01438C2.25462 30 0 27.7454 0 24.9856V5.01437C0 2.25462 2.25462 0 5.01438 0H24.9856C27.7454 0 30 2.25462 30 5.01437V24.9856C30 27.7577 27.7577 30 24.9856 30ZM15.0061 22.7061C12.9486 22.7061 11.0143 21.9053 9.56053 20.4515C8.10673 18.9977 7.30591 17.0634 7.30591 15.0059C7.30591 12.9484 8.10673 11.0141 9.56053 9.56028C11.0143 8.10649 12.9486 7.30566 15.0061 7.30566C17.0636 7.30566 18.9979 8.10649 20.4517 9.56028C21.9055 11.0141 22.7063 12.9484 22.7063 15.0059C22.7063 17.0634 21.9055 18.9977 20.4517 20.4515C18.9856 21.9053 17.0636 22.7061 15.0061 22.7061ZM15.0061 8.94427C11.6673 8.94427 8.94451 11.6547 8.94451 15.0059C8.94451 18.3447 11.655 21.0675 15.0061 21.0675C18.3449 21.0675 21.0677 18.357 21.0677 15.0059C21.0554 11.6671 18.3449 8.94427 15.0061 8.94427ZM25.6855 5.57418C25.6855 6.39072 25.0235 7.05266 24.207 7.05266C23.3905 7.05266 22.7285 6.39072 22.7285 5.57418C22.7285 4.75764 23.3905 4.0957 24.207 4.0957C25.0235 4.0957 25.6855 4.75764 25.6855 5.57418Z",
    fill: "#FAF9F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaWhiteLogo);
export default __webpack_public_path__ + "static/media/insta-white-logo.4e0b3788a4fc262eec9eb0b017f4abfa.svg";
export { ForwardRef as ReactComponent };